export default __webpack_public_path__ + "static/media/Pagenotfound.4861ae77.svg";